// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '일화',
  targetSheetName: '수수료율표_최종',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '제품코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '분류',
    '자체 생산',
    '생동 진행 여부 (자사/위탁)',
    '대분류',
    '소분류',
    '성분 · 함량',
    '제품명',
    '대조약',
    '약가',
    '제품코드',
    '포장단위',
    '수수료',
    '비고',
  ],
});
